<p-toolbar>
  <div class="ui-left">
    @if (!isCompact) {
      @if (isZoomTarget) {
        <button
          class="p-menu-bar-button"
          icon="icon-table"
          iuKeybinding
          iuKeybinding-code="menu-bar-detail.zoom"
            pButton
          showDelay="250"
          tooltipPosition="top"
          type="button"
          [attr.aria-label]="'menuBarDetails.zoom' | translate"
          [hideDelay]="250"
          [iuKeybinding-active]="activateKeybind && !isSplitView"
          [iuKeybinding-focusTab]="activeTabID"
          [life]="3000"
          pTooltip="{{ 'menuBarDetails.zoom' | translate }}"
          (click)="changeGridViewVisibility?.emit($event)">
          {{ '' }}
        </button>
        <span aria-hidden="true" class="menu-bar-separator"></span>
      }
      <button
        class="p-menu-bar-button"
        data-cy="button-newRecord"
        icon="icon-add"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.new"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [attr.aria-label]="'menuBarDetails.add' | translate"
        [disabled]="!newBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.add' | translate }}"
        (click)="newEvent?.emit($event)">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-saveRecord"
        icon="icon-save3x"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.save"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [attr.aria-label]="'menuBarDetails.save' | translate"
        [disabled]="!saveBtnCondition || saving"
        [loading]="saving"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [attr.data-cy-unsaved]="isDirty ? 'Y' : 'N'"
        [class.iu-just-saved]="justSaved"
        [life]="3000"
        pTooltip="{{
          isDirty
            ? ('menuBarDetails.save' | translate) + ' - ' + ('menuBarDetails.unsavedChanges' | translate)
            : ('menuBarDetails.save' | translate)
        }}"
        (click)="saveEvent?.emit($event)">
        @if (isDirty) {
          <span aria-hidden="true" class="unsaved-dot"></span>
        }
        @if (justSaved) {
          <!-- saved: a check a moment on the button (micro-interactions.scss) -->
          <i aria-hidden="true" class="iu-saved-check fa-solid fa-check"></i>
        }
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-refresh"
        icon="icon-refresh3x"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.refresh"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [attr.aria-label]="'menuBarDetails.refresh' | translate"
        [disabled]="!refreshBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.refresh' | translate }}"
        (click)="refreshEvent?.emit($event)">
        {{ '' }}
      </button>
      <span aria-hidden="true" class="menu-bar-separator"></span>
      <button
        class="p-menu-bar-button menu-bar-button-danger"
        data-cy="button-delete"
        icon="icon-delete"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.delete"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [attr.aria-label]="'menuBarDetails.delete' | translate"
        [disabled]="!deleteBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.delete' | translate }}"
        (click)="deleteEvent?.emit($event)">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-copy"
        icon="icon-copy"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.copy"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [attr.aria-label]="'menuBarDetails.copy' | translate"
        [disabled]="!copyBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.copy' | translate }}"
        (click)="copyEvent?.emit($event)">
        {{ '' }}
      </button>
    }
  </div>

  <div class="ui-center">
    @if (!isZoomEditView && !isZoomTarget && arrowsDisplayed) {
      <span
        class="arrow back-arrow icon-back"
        iuKeybinding
        role="button"
        tabindex="0"
        [attr.aria-label]="'menuBarDetails.previousRecord' | translate"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-code]="'menu-bar-detail.back'"
        [iuKeybinding-focusTab]="activeTabID"
        [iuKeybinding-shift]="false"
        (click)="changeGridElementEvent.emit(-1)"
        (keydown.enter)="changeGridElementEvent.emit(-1)"
        (keydown.space)="$event.preventDefault(); changeGridElementEvent.emit(-1)"></span>
    }
    <span
      class="tabTitle"
      data-cy="show-changelog"
      role="button"
      tabindex="0"
      showDelay="250"
      tooltipPosition="top"
      [hideDelay]="250"
      [life]="3000"
      pTooltip="{{ viewRecordChangeLogLabel }}"
      (click)="viewRecordChangeLog.emit($event)"
      (keydown.enter)="viewRecordChangeLog.emit($event)"
      (keydown.space)="$event.preventDefault(); viewRecordChangeLog.emit($event)">
      {{ viewRecordChangeLogLabel }}
    </span>
    <span class="newSymbol">{{ status === 'sync' ? '' : ' *' }}</span>
    @if (!isZoomEditView && !isZoomTarget && arrowsDisplayed) {
      <span
        class="arrow next-arrow icon-next"
        iuKeybinding
        role="button"
        tabindex="0"
        [attr.aria-label]="'menuBarDetails.nextRecord' | translate"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-code]="'menu-bar-detail.next'"
        [iuKeybinding-focusTab]="activeTabID"
        [iuKeybinding-shift]="false"
        (click)="changeGridElementEvent.emit(1)"
        (keydown.enter)="changeGridElementEvent.emit(1)"
        (keydown.space)="$event.preventDefault(); changeGridElementEvent.emit(1)"></span>
    }
  </div>

  <div class="ui-right">
    @if (!isCompact) {
      <button
        class="p-menu-bar-button"
        data-cy="button-email"
        icon="icon-mail"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.email"
        pButton
        showDelay="250"
        tooltipPosition="left"
        type="button"
        [attr.aria-label]="'menuBarDetails.email' | translate"
        [disabled]="!mailBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.email' | translate }}"
        (click)="emailEvent?.emit($event)">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-note"
        icon="icon-notes"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.note"
        pButton
        showDelay="250"
        tooltipPosition="left"
        type="button"
        [attr.aria-label]="'menuBarDetails.note' | translate"
        [disabled]="!noteBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.note' | translate }}"
        (click)="noteEvent?.emit($event)">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-request"
        icon="icon-document"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.request"
        pButton
        showDelay="250"
        style="overflow: visible"
        tooltipPosition="left"
        type="button"
        [attr.aria-label]="'menuBarDetails.request' | translate"
        [disabled]="!requestBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.request' | translate }}"
        (click)="requestEvent?.emit($event)">
        @if (nbRequest !== undefined && nbRequest > 0) {
          <span class="iupics-badge iupics-badge-count" style="top: 0; right: -2px">{{
            nbRequest > 9 ? '9+' : nbRequest
          }}</span>
        }
      </button>
      <span aria-hidden="true" class="menu-bar-separator"></span>
      <button
        class="p-menu-bar-button"
        data-cy="button-attachFile"
        icon="icon-attach3x"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.join"
        pButton
        showDelay="250"
        style="overflow: visible"
        tooltipPosition="left"
        type="button"
        [attr.aria-label]="'menuBarDetails.joinFiles' | translate"
        [disabled]="!joinFileBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.joinFiles' | translate }}"
        (click)="joinFilesEvent?.emit($event)">
        @if (nbUploadedFiles !== undefined && nbUploadedFiles > 0) {
          <span class="iupics-badge iupics-badge-count" style="top: 0; right: -2px">{{
            nbUploadedFiles > 9 ? '9+' : nbUploadedFiles
          }}</span>
        }
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-export"
        icon="icon-export"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.export"
        pButton
        showDelay="250"
        tooltipPosition="left"
        type="button"
        [attr.aria-label]="'menuBarDetails.export' | translate"
        [disabled]="!exportBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.export' | translate }}"
        (click)="exportDataEvent?.emit($event)">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-print"
        icon="icon-print"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.print"
        pButton
        showDelay="250"
        tooltipPosition="left"
        type="button"
        [attr.aria-label]="'menuBarDetails.print' | translate"
        [disabled]="!printBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.print' | translate }}"
        (click)="printEvent?.emit($event)">
        {{ '' }}
      </button>
      <span aria-hidden="true" class="menu-bar-separator"></span>
    }
    <button
      class="p-menu-bar-button"
      data-cy="button-closeBlade"
      icon="icon-close"
      iuKeybinding
      iuKeybinding-code="menu-bar-detail.close"
      pButton
      type="button"
      [attr.aria-label]="'menuBarDetails.close' | translate"
      [hideDelay]="250"
      [iuKeybinding-active]="activateKeybind && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ 'menuBarDetails.close' | translate }}"
      (click)="closeEvent.emit($event)">
      {{ '' }}
    </button>
  </div>
</p-toolbar>

@if (showMoreAction) {
  @if (isCompact && activateKeybind && !isSplitView) {
    <div aria-hidden="true" class="more-action-backdrop" (click)="showMoreAction = false"></div>
  }
  <!-- compact mode: the sheet closes once an action is picked -->
  <div
    class="more-action"
    [class.more-action--sheet]="isCompact && activateKeybind && !isSplitView"
    (click)="isCompact ? (showMoreAction = false) : null">
    <!-- the bottom nav is hidden while this edit view shows its fixed bar: same shortcuts here -->
    @if (isCompact && activateKeybind && !isSplitView) {
      <nav
        class="more-action-nav"
        data-cy="more-action-nav"
        [attr.aria-label]="'menuBarDetails.mobileNavigation' | translate">
        <button class="mobile-action" data-cy="more-nav-dashboard" type="button" (click)="mobileNav.trigger('dashboard')">
          <span aria-hidden="true" class="mobile-action-icon icon-house"></span>
          <span class="mobile-action-label">{{ 'menuTop.navHome' | translate }}</span>
        </button>
        <button class="mobile-action" data-cy="more-nav-menu" type="button" (click)="mobileNav.trigger('menu')">
          <span aria-hidden="true" class="mobile-action-icon icon-menu-bars"></span>
          <span class="mobile-action-label">{{ 'menuTop.navMenu' | translate }}</span>
        </button>
        <button class="mobile-action" data-cy="more-nav-search" type="button" (click)="mobileNav.trigger('search')">
          <span aria-hidden="true" class="mobile-action-icon icon-search-bolder"></span>
          <span class="mobile-action-label">{{ 'menuTop.navSearch' | translate }}</span>
        </button>
        <button
          class="mobile-action"
          data-cy="more-nav-notifications"
          type="button"
          [attr.aria-label]="('menuTop.notif' | translate) + ' (' + mobileNav.nbNotifications() + ')'"
          (click)="mobileNav.trigger('notifications')">
          <span aria-hidden="true" class="mobile-action-icon icon-bell"></span>
          @if (mobileNav.nbNotifications() > 0) {
            <span aria-hidden="true" class="more-action-nav-badge">{{
              mobileNav.nbNotifications() > 99 ? '99+' : mobileNav.nbNotifications()
            }}</span>
          }
          <span class="mobile-action-label">{{ 'menuTop.navNotif' | translate }}</span>
        </button>
        <button class="mobile-action" data-cy="more-nav-profile" type="button" (click)="mobileNav.trigger('profile')">
          <span aria-hidden="true" class="mobile-action-icon icon-user-circle"></span>
          <span class="mobile-action-label">{{ 'menuTop.navProfile' | translate }}</span>
        </button>
      </nav>
      <!-- same items and handlers as the edit view "Processus" dropdown and smart buttons row -->
      @if (sheetProcesses.length > 0) {
        <section class="more-action-section" data-cy="more-action-processes">
          <h3 class="more-action-section-title">{{ 'editView.processes' | translate }}</h3>
          @for (process of sheetProcesses; track process.componentUUID) {
            <button
              class="more-action-row"
              data-cy="more-action-process"
              type="button"
              [attr.data-cy-process-id]="process.processId"
              [class.readonly]="process.readOnly"
              (click)="processEvent.emit(process)">
              <span aria-hidden="true" class="more-action-row-icon fas fa-cog"></span>
              <span class="more-action-row-label">{{ process.label }}</span>
            </button>
          }
        </section>
      }
      @if (sheetSmartButtons.length > 0) {
        <section class="more-action-section" data-cy="more-action-smartbuttons">
          <h3 class="more-action-section-title">{{ 'menuBarDetails.mobileActions' | translate }}</h3>
          @for (button of sheetSmartButtons; track button.key) {
            <button
              class="more-action-row"
              data-cy="more-action-smartbutton"
              type="button"
              (click)="toggleSmartButton(button.key)">
              <span aria-hidden="true" class="more-action-row-icon {{ button.icon || 'icon-next' }}"></span>
              <span class="more-action-row-label">{{ button.name }}</span>
            </button>
          }
        </section>
      }
    }
    @if (isZoomTarget) {
      <button
        class="p-menu-bar-button"
        icon="icon-table"
        pButton
        type="button"
        [attr.aria-label]="'menuBarDetails.zoom' | translate"
        (click)="changeGridViewVisibility?.emit($event)">
        {{ '' }}
      </button>
    }
    <button
      class="p-menu-bar-button"
      data-cy="button-copy"
      icon="icon-copy"
      pButton
      type="button"
        [attr.aria-label]="'menuBarDetails.copy' | translate"
      [disabled]="!copyBtnCondition"
      (click)="copyEvent?.emit($event)">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-email"
      icon="icon-mail"
      pButton
      type="button"
        [attr.aria-label]="'menuBarDetails.email' | translate"
      [disabled]="!mailBtnCondition"
      (click)="emailEvent?.emit($event)">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button notes-button"
      data-cy="button-note"
      icon="icon-notes"
      pButton
      type="button"
        [attr.aria-label]="'menuBarDetails.note' | translate"
      [disabled]="!noteBtnCondition"
      (click)="noteEvent?.emit($event)">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-attachFile"
      icon="icon-attach3x"
      pButton
      type="button"
        [attr.aria-label]="'menuBarDetails.joinFiles' | translate"
      [disabled]="!joinFileBtnCondition"
      (click)="joinFilesEvent?.emit($event)">
      @if (nbUploadedFiles !== undefined && nbUploadedFiles > 0) {
        <span class="iupics-badge iupics-badge-count">{{ nbUploadedFiles > 9 ? '9+' : nbUploadedFiles }}</span>
      }
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-export"
      icon="icon-export"
      pButton
      type="button"
        [attr.aria-label]="'menuBarDetails.export' | translate"
      [disabled]="!exportBtnCondition"
      (click)="exportDataEvent?.emit($event)">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-print"
      icon="icon-print"
      pButton
      type="button"
        [attr.aria-label]="'menuBarDetails.print' | translate"
      [disabled]="!printBtnCondition"
      (click)="printEvent?.emit($event)">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      icon="icon-close"
      pButton
      type="button"
      [attr.aria-label]="'menuBarDetails.close' | translate"
      (click)="closeEvent.emit($event)">
      {{ '' }}
    </button>
  </div>
}

<!-- compact (mobile / narrow) mode: main actions in a bar fixed at the bottom of the screen -->
@if (isCompact) {
  <div class="iu-mobile-bottom-area" [class.iu-mobile-action-bar--fixed]="activateKeybind && !isSplitView">
    <!-- thumb reach: previous / next record (breadcrumb navigation = existing swipe) -->
    @if (isFixedBar && recordArrowsVisible) {
      <div class="iu-mobile-record-nav" data-cy="mobile-record-nav">
        @if (recordArrowsVisible) {
          <div class="mobile-record-arrows">
            <button
              class="mobile-record-arrow"
              data-cy="mobile-button-previousRecord"
              type="button"
              [attr.aria-label]="'menuBarDetails.previousRecord' | translate"
              [disabled]="recordIndex === 0"
              (click)="changeGridElementEvent.emit(-1)">
              <span aria-hidden="true" class="icon-back"></span>
            </button>
            @if (recordIndex >= 0) {
              <span class="mobile-record-position" data-cy="mobile-record-position">{{ recordIndex + 1 }}</span>
            }
            <button
              class="mobile-record-arrow"
              data-cy="mobile-button-nextRecord"
              type="button"
              [attr.aria-label]="'menuBarDetails.nextRecord' | translate"
              [disabled]="isLastRecord"
              (click)="changeGridElementEvent.emit(1)">
              <span aria-hidden="true" class="icon-next"></span>
            </button>
          </div>
        }
      </div>
    }
    <nav class="iu-mobile-action-bar" [attr.aria-label]="'menuBarDetails.showButtons' | translate">
      <button
        class="mobile-action"
        data-cy="mobile-button-newRecord"
        type="button"
        [disabled]="!newBtnCondition"
        (click)="newEvent.emit($event)">
        <span aria-hidden="true" class="mobile-action-icon icon-add"></span>
        <span class="mobile-action-label">{{ 'menuBarDetails.mobileNew' | translate }}</span>
      </button>
      <button
        class="mobile-action"
        data-cy="mobile-button-saveRecord"
        type="button"
        [attr.data-cy-unsaved]="isDirty ? 'Y' : 'N'"
        [class.iu-just-saved]="justSaved"
        [attr.title]="isDirty ? ('menuBarDetails.unsavedChanges' | translate) : null"
        [attr.aria-busy]="saving"
        [disabled]="!saveBtnCondition || saving"
        (click)="saveEvent.emit($event)">
        <span aria-hidden="true" class="mobile-action-icon icon-save3x">
          @if (isDirty) {
            <span class="unsaved-dot"></span>
          }
          @if (justSaved) {
            <i class="iu-saved-check fa-solid fa-check"></i>
          }
        </span>
        <span class="mobile-action-label">{{ 'menuBarDetails.save' | translate }}</span>
      </button>
      <button
        class="mobile-action"
        data-cy="mobile-button-refresh"
        type="button"
        [disabled]="!refreshBtnCondition"
        (click)="refreshEvent.emit($event)">
        <span aria-hidden="true" class="mobile-action-icon icon-refresh3x"></span>
        <span class="mobile-action-label">{{
          (isDirty ? 'menuBarDetails.mobileDiscard' : 'menuBarDetails.refresh') | translate
        }}</span>
      </button>
      <button
        class="mobile-action mobile-action--danger"
        data-cy="mobile-button-delete"
        type="button"
        [disabled]="!deleteBtnCondition"
        (click)="deleteEvent.emit($event)">
        <span aria-hidden="true" class="mobile-action-icon icon-delete"></span>
        <span class="mobile-action-label">{{ 'menuBarDetails.mobileDelete' | translate }}</span>
      </button>
      <button
        class="mobile-action"
        data-cy="menuBar-showButtons-btn"
        type="button"
        [attr.aria-expanded]="showMoreAction"
        [attr.data-cy-toggle-state]="showMoreAction ? 'opened' : 'closed'"
        [class.mobile-action--open]="showMoreAction"
        (click)="showMoreActionEmitter.emit($event)">
        <span aria-hidden="true" class="mobile-action-icon icon-menu-bars"></span>
        <span class="mobile-action-label">{{ 'menuBarDetails.more' | translate }}</span>
      </button>
    </nav>
  </div>
}
